/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * Souq Crypto API - Dubai USDT marketplace
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminListApplicationsParams,
  AdminListInquiriesParams,
  Application,
  ApplicationInput,
  ApplicationStatusUpdate,
  Category,
  ErrorResponse,
  HealthStatus,
  Inquiry,
  InquiryInput,
  ListListingsParams,
  ListMerchantsParams,
  Listing,
  ListingDetail,
  ListingImagePublishRequest,
  ListingImagePublishResponse,
  ListingImageUploadRequest,
  ListingImageUploadResponse,
  ListingInput,
  ListingPage,
  ListingUpdate,
  MarketplaceStats,
  Merchant,
  MerchantLocationUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCategoriesUrl = () => {




  return `/api/categories`
}

/**
 * @summary List all categories
 */
export const listCategories = async ( options?: Parameters<typeof customFetch>[1]): Promise<Category[]> => {

  return customFetch<Category[]>(getListCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCategoriesQueryKey = () => {
    return [
    `/api/categories`
    ] as const;
    }


export const getListCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({ signal }) => listCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type ListCategoriesQueryError = ErrorType<unknown>


/**
 * @summary List all categories
 */

export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMerchantsUrl = (params?: ListMerchantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/merchants?${stringifiedParams}` : `/api/merchants`
}

/**
 * @summary List merchants
 */
export const listMerchants = async (params?: ListMerchantsParams, options?: Parameters<typeof customFetch>[1]): Promise<Merchant[]> => {

  return customFetch<Merchant[]>(getListMerchantsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMerchantsQueryKey = (params?: ListMerchantsParams,) => {
    return [
    `/api/merchants`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMerchantsQueryOptions = <TData = Awaited<ReturnType<typeof listMerchants>>, TError = ErrorType<unknown>>(params?: ListMerchantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMerchants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMerchantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMerchants>>> = ({ signal }) => listMerchants(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMerchants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMerchantsQueryResult = NonNullable<Awaited<ReturnType<typeof listMerchants>>>
export type ListMerchantsQueryError = ErrorType<unknown>


/**
 * @summary List merchants
 */

export function useListMerchants<TData = Awaited<ReturnType<typeof listMerchants>>, TError = ErrorType<unknown>>(
 params?: ListMerchantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMerchants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMerchantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMerchantUrl = (id: string,) => {




  return `/api/merchants/${id}`
}

/**
 * @summary Get a merchant by slug or ID
 */
export const getMerchant = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Merchant> => {

  return customFetch<Merchant>(getGetMerchantUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMerchantQueryKey = (id: string,) => {
    return [
    `/api/merchants/${id}`
    ] as const;
    }


export const getGetMerchantQueryOptions = <TData = Awaited<ReturnType<typeof getMerchant>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMerchant>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMerchantQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMerchant>>> = ({ signal }) => getMerchant(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMerchant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMerchantQueryResult = NonNullable<Awaited<ReturnType<typeof getMerchant>>>
export type GetMerchantQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a merchant by slug or ID
 */

export function useGetMerchant<TData = Awaited<ReturnType<typeof getMerchant>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMerchant>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMerchantQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListListingsUrl = (params?: ListListingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/listings?${stringifiedParams}` : `/api/listings`
}

/**
 * @summary Search and filter listings
 */
export const listListings = async (params?: ListListingsParams, options?: Parameters<typeof customFetch>[1]): Promise<ListingPage> => {

  return customFetch<ListingPage>(getListListingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListListingsQueryKey = (params?: ListListingsParams,) => {
    return [
    `/api/listings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListListingsQueryOptions = <TData = Awaited<ReturnType<typeof listListings>>, TError = ErrorType<unknown>>(params?: ListListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListListingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listListings>>> = ({ signal }) => listListings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listListings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListListingsQueryResult = NonNullable<Awaited<ReturnType<typeof listListings>>>
export type ListListingsQueryError = ErrorType<unknown>


/**
 * @summary Search and filter listings
 */

export function useListListings<TData = Awaited<ReturnType<typeof listListings>>, TError = ErrorType<unknown>>(
 params?: ListListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListListingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetListingUrl = (id: string,) => {




  return `/api/listings/${id}`
}

/**
 * @summary Get a listing by slug or ID
 */
export const getListing = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ListingDetail> => {

  return customFetch<ListingDetail>(getGetListingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetListingQueryKey = (id: string,) => {
    return [
    `/api/listings/${id}`
    ] as const;
    }


export const getGetListingQueryOptions = <TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<ErrorResponse>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListing>>> = ({ signal }) => getListing(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingQueryResult = NonNullable<Awaited<ReturnType<typeof getListing>>>
export type GetListingQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a listing by slug or ID
 */

export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<ErrorResponse>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSimilarListingsUrl = (id: string,) => {




  return `/api/listings/${id}/similar`
}

/**
 * @summary Get similar listings
 */
export const getSimilarListings = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Listing[]> => {

  return customFetch<Listing[]>(getGetSimilarListingsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimilarListingsQueryKey = (id: string,) => {
    return [
    `/api/listings/${id}/similar`
    ] as const;
    }


export const getGetSimilarListingsQueryOptions = <TData = Awaited<ReturnType<typeof getSimilarListings>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimilarListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimilarListingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimilarListings>>> = ({ signal }) => getSimilarListings(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimilarListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSimilarListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimilarListings>>>
export type GetSimilarListingsQueryError = ErrorType<unknown>


/**
 * @summary Get similar listings
 */

export function useGetSimilarListings<TData = Awaited<ReturnType<typeof getSimilarListings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSimilarListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSimilarListingsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStatsUrl = () => {




  return `/api/stats`
}

/**
 * @summary Get marketplace stats
 */
export const getStats = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceStats> => {

  return customFetch<MarketplaceStats>(getGetStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatsQueryKey = () => {
    return [
    `/api/stats`
    ] as const;
    }


export const getGetStatsQueryOptions = <TData = Awaited<ReturnType<typeof getStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStats>>> = ({ signal }) => getStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getStats>>>
export type GetStatsQueryError = ErrorType<unknown>


/**
 * @summary Get marketplace stats
 */

export function useGetStats<TData = Awaited<ReturnType<typeof getStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitApplicationUrl = () => {




  return `/api/applications`
}

/**
 * @summary Submit a merchant application
 */
export const submitApplication = async (applicationInput: ApplicationInput, options?: Parameters<typeof customFetch>[1]): Promise<Application> => {

  return customFetch<Application>(getSubmitApplicationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(applicationInput)
  }
);}





export const getSubmitApplicationMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitApplication>>, TError,{data: BodyType<ApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitApplication>>, TError,{data: BodyType<ApplicationInput>}, TContext> => {

const mutationKey = ['submitApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitApplication>>, {data: BodyType<ApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof submitApplication>>>
    export type SubmitApplicationMutationBody = BodyType<ApplicationInput>
    export type SubmitApplicationMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit a merchant application
 */
export const useSubmitApplication = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitApplication>>, TError,{data: BodyType<ApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitApplication>>,
        TError,
        {data: BodyType<ApplicationInput>},
        TContext
      > => {
      return useMutation(getSubmitApplicationMutationOptions(options));
    }

export const getSubmitInquiryUrl = () => {




  return `/api/inquiries`
}

/**
 * @summary Submit an inquiry about a listing
 */
export const submitInquiry = async (inquiryInput: InquiryInput, options?: Parameters<typeof customFetch>[1]): Promise<Inquiry> => {

  return customFetch<Inquiry>(getSubmitInquiryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inquiryInput)
  }
);}





export const getSubmitInquiryMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInquiry>>, TError,{data: BodyType<InquiryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitInquiry>>, TError,{data: BodyType<InquiryInput>}, TContext> => {

const mutationKey = ['submitInquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitInquiry>>, {data: BodyType<InquiryInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitInquiry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitInquiryMutationResult = NonNullable<Awaited<ReturnType<typeof submitInquiry>>>
    export type SubmitInquiryMutationBody = BodyType<InquiryInput>
    export type SubmitInquiryMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit an inquiry about a listing
 */
export const useSubmitInquiry = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInquiry>>, TError,{data: BodyType<InquiryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitInquiry>>,
        TError,
        {data: BodyType<InquiryInput>},
        TContext
      > => {
      return useMutation(getSubmitInquiryMutationOptions(options));
    }

export const getAdminListApplicationsUrl = (params?: AdminListApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/applications?${stringifiedParams}` : `/api/admin/applications`
}

/**
 * @summary List all merchant applications (admin)
 */
export const adminListApplications = async (params?: AdminListApplicationsParams, options?: Parameters<typeof customFetch>[1]): Promise<Application[]> => {

  return customFetch<Application[]>(getAdminListApplicationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListApplicationsQueryKey = (params?: AdminListApplicationsParams,) => {
    return [
    `/api/admin/applications`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof adminListApplications>>, TError = ErrorType<ErrorResponse>>(params?: AdminListApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListApplicationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListApplications>>> = ({ signal }) => adminListApplications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListApplications>>>
export type AdminListApplicationsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all merchant applications (admin)
 */

export function useAdminListApplications<TData = Awaited<ReturnType<typeof adminListApplications>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminListApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListApplicationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminUpdateApplicationUrl = (id: number,) => {




  return `/api/admin/applications/${id}`
}

/**
 * @summary Update application status (admin). Approving an application creates one linked, unpublished merchant and listing draft; repeated approval returns the original linked draft.
 */
export const adminUpdateApplication = async (id: number,
    applicationStatusUpdate: ApplicationStatusUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Application> => {

  return customFetch<Application>(getAdminUpdateApplicationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(applicationStatusUpdate)
  }
);}





export const getAdminUpdateApplicationMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateApplication>>, TError,{id: number;data: BodyType<ApplicationStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateApplication>>, TError,{id: number;data: BodyType<ApplicationStatusUpdate>}, TContext> => {

const mutationKey = ['adminUpdateApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateApplication>>, {id: number;data: BodyType<ApplicationStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateApplication(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateApplication>>>
    export type AdminUpdateApplicationMutationBody = BodyType<ApplicationStatusUpdate>
    export type AdminUpdateApplicationMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update application status (admin). Approving an application creates one linked, unpublished merchant and listing draft; repeated approval returns the original linked draft.
 */
export const useAdminUpdateApplication = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateApplication>>, TError,{id: number;data: BodyType<ApplicationStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateApplication>>,
        TError,
        {id: number;data: BodyType<ApplicationStatusUpdate>},
        TContext
      > => {
      return useMutation(getAdminUpdateApplicationMutationOptions(options));
    }

export const getAdminListInquiriesUrl = (params?: AdminListInquiriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/inquiries?${stringifiedParams}` : `/api/admin/inquiries`
}

/**
 * @summary List all inquiries (admin)
 */
export const adminListInquiries = async (params?: AdminListInquiriesParams, options?: Parameters<typeof customFetch>[1]): Promise<Inquiry[]> => {

  return customFetch<Inquiry[]>(getAdminListInquiriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListInquiriesQueryKey = (params?: AdminListInquiriesParams,) => {
    return [
    `/api/admin/inquiries`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListInquiriesQueryOptions = <TData = Awaited<ReturnType<typeof adminListInquiries>>, TError = ErrorType<ErrorResponse>>(params?: AdminListInquiriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListInquiries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListInquiriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListInquiries>>> = ({ signal }) => adminListInquiries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListInquiries>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListInquiriesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListInquiries>>>
export type AdminListInquiriesQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all inquiries (admin)
 */

export function useAdminListInquiries<TData = Awaited<ReturnType<typeof adminListInquiries>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminListInquiriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListInquiries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListInquiriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminUpdateMerchantUrl = (id: number,) => {




  return `/api/admin/merchants/${id}`
}

/**
 * @summary Update a merchant (admin) — currently supports setting exact latitude/longitude
 */
export const adminUpdateMerchant = async (id: number,
    merchantLocationUpdate: MerchantLocationUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Merchant> => {

  return customFetch<Merchant>(getAdminUpdateMerchantUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(merchantLocationUpdate)
  }
);}





export const getAdminUpdateMerchantMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateMerchant>>, TError,{id: number;data: BodyType<MerchantLocationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateMerchant>>, TError,{id: number;data: BodyType<MerchantLocationUpdate>}, TContext> => {

const mutationKey = ['adminUpdateMerchant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateMerchant>>, {id: number;data: BodyType<MerchantLocationUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateMerchant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateMerchantMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateMerchant>>>
    export type AdminUpdateMerchantMutationBody = BodyType<MerchantLocationUpdate>
    export type AdminUpdateMerchantMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a merchant (admin) — currently supports setting exact latitude/longitude
 */
export const useAdminUpdateMerchant = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateMerchant>>, TError,{id: number;data: BodyType<MerchantLocationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateMerchant>>,
        TError,
        {id: number;data: BodyType<MerchantLocationUpdate>},
        TContext
      > => {
      return useMutation(getAdminUpdateMerchantMutationOptions(options));
    }

export const getAdminCreateListingUrl = () => {




  return `/api/admin/listings`
}

/**
 * @summary Create a listing (admin)
 */
export const adminCreateListing = async (listingInput: ListingInput, options?: Parameters<typeof customFetch>[1]): Promise<ListingDetail> => {

  return customFetch<ListingDetail>(getAdminCreateListingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingInput)
  }
);}





export const getAdminCreateListingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateListing>>, TError,{data: BodyType<ListingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateListing>>, TError,{data: BodyType<ListingInput>}, TContext> => {

const mutationKey = ['adminCreateListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateListing>>, {data: BodyType<ListingInput>}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateListing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateListingMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateListing>>>
    export type AdminCreateListingMutationBody = BodyType<ListingInput>
    export type AdminCreateListingMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a listing (admin)
 */
export const useAdminCreateListing = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateListing>>, TError,{data: BodyType<ListingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminCreateListing>>,
        TError,
        {data: BodyType<ListingInput>},
        TContext
      > => {
      return useMutation(getAdminCreateListingMutationOptions(options));
    }

export const getAdminRequestListingImageUploadUrlUrl = () => {




  return `/api/admin/listing-images/upload-url`
}

/**
 * The browser uploads the image directly to App Storage using the returned URL.
 * @summary Request a presigned image upload URL (admin)
 */
export const adminRequestListingImageUploadUrl = async (listingImageUploadRequest: ListingImageUploadRequest, options?: Parameters<typeof customFetch>[1]): Promise<ListingImageUploadResponse> => {

  return customFetch<ListingImageUploadResponse>(getAdminRequestListingImageUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingImageUploadRequest)
  }
);}





export const getAdminRequestListingImageUploadUrlMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRequestListingImageUploadUrl>>, TError,{data: BodyType<ListingImageUploadRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRequestListingImageUploadUrl>>, TError,{data: BodyType<ListingImageUploadRequest>}, TContext> => {

const mutationKey = ['adminRequestListingImageUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRequestListingImageUploadUrl>>, {data: BodyType<ListingImageUploadRequest>}> = (props) => {
          const {data} = props ?? {};

          return  adminRequestListingImageUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRequestListingImageUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof adminRequestListingImageUploadUrl>>>
    export type AdminRequestListingImageUploadUrlMutationBody = BodyType<ListingImageUploadRequest>
    export type AdminRequestListingImageUploadUrlMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Request a presigned image upload URL (admin)
 */
export const useAdminRequestListingImageUploadUrl = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRequestListingImageUploadUrl>>, TError,{data: BodyType<ListingImageUploadRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminRequestListingImageUploadUrl>>,
        TError,
        {data: BodyType<ListingImageUploadRequest>},
        TContext
      > => {
      return useMutation(getAdminRequestListingImageUploadUrlMutationOptions(options));
    }

export const getAdminPublishListingImageUrl = () => {




  return `/api/admin/listing-images/publish`
}

/**
 * @summary Validate and publish a staged listing image (admin)
 */
export const adminPublishListingImage = async (listingImagePublishRequest: ListingImagePublishRequest, options?: Parameters<typeof customFetch>[1]): Promise<ListingImagePublishResponse> => {

  return customFetch<ListingImagePublishResponse>(getAdminPublishListingImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingImagePublishRequest)
  }
);}





export const getAdminPublishListingImageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPublishListingImage>>, TError,{data: BodyType<ListingImagePublishRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPublishListingImage>>, TError,{data: BodyType<ListingImagePublishRequest>}, TContext> => {

const mutationKey = ['adminPublishListingImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPublishListingImage>>, {data: BodyType<ListingImagePublishRequest>}> = (props) => {
          const {data} = props ?? {};

          return  adminPublishListingImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPublishListingImageMutationResult = NonNullable<Awaited<ReturnType<typeof adminPublishListingImage>>>
    export type AdminPublishListingImageMutationBody = BodyType<ListingImagePublishRequest>
    export type AdminPublishListingImageMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Validate and publish a staged listing image (admin)
 */
export const useAdminPublishListingImage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPublishListingImage>>, TError,{data: BodyType<ListingImagePublishRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminPublishListingImage>>,
        TError,
        {data: BodyType<ListingImagePublishRequest>},
        TContext
      > => {
      return useMutation(getAdminPublishListingImageMutationOptions(options));
    }

export const getAdminUpdateListingUrl = (id: number,) => {




  return `/api/admin/listings/${id}`
}

/**
 * @summary Update a listing (admin)
 */
export const adminUpdateListing = async (id: number,
    listingUpdate: ListingUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ListingDetail> => {

  return customFetch<ListingDetail>(getAdminUpdateListingUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingUpdate)
  }
);}





export const getAdminUpdateListingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateListing>>, TError,{id: number;data: BodyType<ListingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateListing>>, TError,{id: number;data: BodyType<ListingUpdate>}, TContext> => {

const mutationKey = ['adminUpdateListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateListing>>, {id: number;data: BodyType<ListingUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateListing(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateListingMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateListing>>>
    export type AdminUpdateListingMutationBody = BodyType<ListingUpdate>
    export type AdminUpdateListingMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a listing (admin)
 */
export const useAdminUpdateListing = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateListing>>, TError,{id: number;data: BodyType<ListingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateListing>>,
        TError,
        {id: number;data: BodyType<ListingUpdate>},
        TContext
      > => {
      return useMutation(getAdminUpdateListingMutationOptions(options));
    }

export const getAdminDeleteListingUrl = (id: number,) => {




  return `/api/admin/listings/${id}`
}

/**
 * @summary Delete a listing (admin)
 */
export const adminDeleteListing = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAdminDeleteListingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteListingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteListing>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteListing>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteListing>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteListing(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteListingMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteListing>>>

    export type AdminDeleteListingMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a listing (admin)
 */
export const useAdminDeleteListing = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteListing>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteListing>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteListingMutationOptions(options));
    }

